var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image-empty",attrs:{"alt":_vm.imageTitle,"src":"data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="}})}
var staticRenderFns = []

export { render, staticRenderFns }